import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { database } from '../config';
import SiteLayout, { PageHero } from './SiteLayout';

function LoginPage() {
  const history = useNavigate();
  const [username, setUserName] = useState('');
  const [password, setpassword] = useState('');

  function login(ev) {
    ev.preventDefault();
    signInWithEmailAndPassword(database, username, password)
      .then(() => history('/getAllNews'))
      .catch((err) => alert(err.code));
  }

  return (
    <SiteLayout>
      <main>
        <PageHero eyebrow="Admin" title="Admin login">
          Sign in to manage Raising Smiles news updates.
        </PageHero>
        <section className="section-padding admin-section">
          <div className="container">
            <form className="custom-form modern-form admin-form" onSubmit={login}>
              <h2>Welcome back</h2>
              <label htmlFor="admin-email">Username</label>
              <input
                type="email"
                name="admin-email"
                id="admin-email"
                className="form-control"
                placeholder="admin@example.com"
                value={username}
                onChange={(ev) => setUserName(ev.target.value)}
                required
              />
              <label htmlFor="admin-password">Password</label>
              <input
                type="password"
                name="admin-password"
                id="admin-password"
                className="form-control"
                placeholder="Password"
                value={password}
                onChange={(ev) => setpassword(ev.target.value)}
                required
              />
              <button type="submit" className="form-control">Login</button>
            </form>
          </div>
        </section>
      </main>
    </SiteLayout>
  );
}

export default LoginPage;
